<template>
  <v-dialog
      :value="value"
      @input="onDialogInput"
      max-width="500"
      persistent
  >
    <v-card>
      <v-card-title class="font-weight-bold">
        Report a problem
      </v-card-title>

      <v-card-text>
        <!-- report type -->
        <v-radio-group
            v-model="reportType"
            row
            class="mb-3"
        >
          <v-radio label="Bug" value="bug" />
          <v-radio label="Suggestion" value="suggestion" />
        </v-radio-group>

        <!-- description -->
        <v-textarea
            v-model="message"
            outlined
            rows="4"
            auto-grow
            label="Description"
            placeholder="What happened? What did you expect?"
        />

        <!-- optional email -->
        <v-text-field
            v-model="email"
            outlined
            dense
            class="mt-3"
            label="Your email (optional)"
            placeholder="example@email.com"
            hint="If provided, we may reply to you about this issue"
            persistent-hint
        />

        <!-- success -->
        <v-alert
            v-if="success"
            type="success"
            dense
            class="mt-3"
        >
          Thank you! Your report has been submitted.
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
            text
            :disabled="submitting"
            @click="close"
        >
          Cancel
        </v-btn>

        <v-btn
            color="primary"
            :loading="submitting"
            :disabled="!message"
            @click="submit"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Axios from "axios";
import {apiprefix} from "@/main";

export default {
  name: "ReportProblemDialog",

  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      reportType: "bug",     // 'bug' | 'suggestion'
      message: "",
      email: "",             // ⭐ 新增
      submitting: false,
      success: false,
    };
  },

  watch: {
    value(val) {
      if (val) {
        this.reset();
      }
    },
  },

  methods: {
    onDialogInput(val) {
      this.$emit("input", val);
    },

    close() {
      this.$emit("input", false);
    },

    reset() {
      this.reportType = "bug";
      this.message = "";
      this.email = "";
      this.success = false;
      this.submitting = false;
    },

    async submit() {
      if (!this.message) return;

      this.submitting = true;

      try {
        await Axios.post(`${apiprefix}/api/report_problem`, {
          report_type: this.reportType,
          message: this.message,
          email: this.email || null,          // ⭐ 可选
          page: this.$route.fullPath,
          user_agent: navigator.userAgent,
        });

        this.success = true;

        setTimeout(() => {
          this.close();
        }, 1200);

      } catch (err) {
        console.error("Report failed:", err);
        alert("Failed to submit report. Please try again later.");
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
